import * as React from 'react';
import {
  Facepile,
  getTheme,
  IButtonStyles,
  IFacepilePersona,
  IFacepileProps,
  ITheme,
  OverflowButtonType,
  PersonaSize
} from '@fluentui/react';
import { UserStat } from 'services';
import { WhiteStatic } from 'theme';

export interface FacepileListProps {
  userList: Array<UserStat>;
  personaSize: PersonaSize;
}

export const FacepileList: React.FunctionComponent<FacepileListProps> = (props: FacepileListProps) => {
  const theme: ITheme = getTheme();

  function getPersonas(): Array<IFacepilePersona> {
    const personaDetails = [] as Array<IFacepilePersona>;
    props.userList.forEach(function(value) {
      const persona = {} as IFacepilePersona;
      persona.personaName = value.preferredUserName;
      persona.data = value.userId;
      persona['color'] = 'white';
      personaDetails.push(persona);
    });
    return personaDetails;
  }

  const style: IButtonStyles = {
    root: {
      backgroundColor: theme.palette.blue
    }
  };

  // Get list of personas for facepile props
  const personasList = getPersonas();

  // Props if there is more than one moderator working queue
  const facepileProps: IFacepileProps = {
    styles: {
      overflowInitialsIcon: {
        color: WhiteStatic
      }
    },
    personaSize: props.personaSize,
    personas: personasList,
    ariaDescription: 'Moderators',
    maxDisplayablePersonas: 3,
    overflowButtonType: OverflowButtonType.descriptive,
    overflowButtonProps: {
      styles: style,
      ariaLabel: 'More moderators'
    },
    getPersonaProps: (persona: IFacepilePersona) => {
      return {
        initialsTextColor: WhiteStatic,
        imageAlt: persona.data as string,
        hidePersonaDetails: true
      };
    }
  };

  const facepileStyles: React.CSSProperties = {
    height: '30px'
  };

  return (
    <div className={`text-center`} style={facepileStyles}>
      <Facepile {...facepileProps} />
    </div>
  );
};
